import {createRoot} from 'react-dom/client'
import './index.css'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
// Apps
import {MetronicI18nProvider} from './_payairo/i18n/Metronici18n'
import './_payairo/assets/fonticon/fonticon.css'
import './_payairo/assets/keenicons/duotone/style.css'
import './_payairo/assets/keenicons/outline/style.css'
import './_payairo/assets/keenicons/solid/style.css'
import './_payairo/assets/sass/style.scss'
import './_payairo/assets/sass/plugins.scss'
import './_payairo/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
// @ts-ignore
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Silence console logs in production builds (keeps app behavior unchanged)
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.log = () => {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.info = () => {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.debug = () => {}
}

setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppRoutes />
          <ToastContainer position='top-right' autoClose={3000} hideProgressBar={false} />
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}
